import { element } from 'protractor';

export class Rutas {
    id: number;
    tag: string;
    valor: string;
    constructor(rutas: IRutas) {
        this.id = rutas && rutas.id ||  0;
        this.tag = rutas && rutas.tag ||  '';
        this.valor = rutas && rutas.valor || '';
        this.formatRuta();
    }

    private formatRuta = () => {
        const ruta = this.valor.split('/');
        const arraySubRuta = this.getOnlyRutas(ruta);
        this.valor = this.generaLink(arraySubRuta)
        
        
    }

    private getOnlyRutas = (rutas) => {
        return rutas.filter((element) => {
            return element !== '';
        });
    }

    private generaLink = (arraySubRuta) => {
        let linksGenerado = '';
        arraySubRuta.map((element, index) => {
            
            if (index === 0) {
                linksGenerado += element + '//';
            } else {
                linksGenerado += element + '/';
            }
            
        });

        return linksGenerado;
    }
}

interface IRutas {
    id: number;
    tag: string;
    valor: string;
}